import { useState } from 'react';
import { useWatch } from 'react-hook-form';
import { useDeepCompareEffect } from 'react-use';
import { isNull } from 'lodash';

import { Anchor, AnchorAlignment, Message, MessageType } from '@dreryk/react-components';

import { AppointmentFormController } from '../AppointmentForm.types';
import { ReceptionServiceTableBean } from '../../../../../receptionService/extensions/calendar/appointment/interactiveTable/ReceptionServiceInteractiveTable.types';

import { useServiceLocationWarningMessageOptions } from './ServiceLocationWarning.hooks';
import { getWarningMessage } from './ServiceLocationWarning.utils';

type ServiceLocationProps = Pick<AppointmentFormController, 'watch' | 'control'>;

export const ServiceLocationWarning = (props: ServiceLocationProps): JSX.Element | null => {
   const [warningMessage, setWarningMessage] = useState<string | null>(null);
   const statusOptions = useServiceLocationWarningMessageOptions();
   const formValues = props.watch();
   const receptionServiceValue = useWatch<ReceptionServiceTableBean[]>({
      name: 'receptionService.value',
      control: props.control,
      defaultValue: formValues.receptionService?.value ?? [],
   });

   useDeepCompareEffect(() => {
      setWarningMessage(getWarningMessage(receptionServiceValue, formValues.healthcareProviderLocation));
   }, [receptionServiceValue, formValues.healthcareProviderLocation]);

   if (isNull(warningMessage)) {
      return null;
   }

   return (
      <Anchor shouldPerformScroll verticalAlignment={AnchorAlignment.END} testId={'serviceLocationWarning'}>
         <Message
            testId={'serviceLocationWarning'}
            type={MessageType.WARNING}
            label={warningMessage}
            displayIndicator
            options={statusOptions}
         />
      </Anchor>
   );
};
